/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionRequestModel } from '../../models/session-request-model';
import { SessionResponseModel } from '../../models/session-response-model';

export interface HealthFindrRequestSessionPost$Params {
      body?: SessionRequestModel
}

export function healthFindrRequestSessionPost(http: HttpClient, rootUrl: string, params?: HealthFindrRequestSessionPost$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<SessionResponseModel>> {
  const rb = new RequestBuilder(rootUrl, healthFindrRequestSessionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<SessionResponseModel>;
    })
  );
}

healthFindrRequestSessionPost.PATH = '/HealthFindr/RequestSession';
